export const PRICE_BOOK_ITEMS_RESET_STATE = 'PRICE_BOOK_ITEMS_RESET_STATE';
export const PRICE_BOOK_ITEMS_CURRENT_ITEM = 'PRICE_BOOK_ITEMS_CURRENT_ITEM';

export const PRICE_BOOK_ITEMS_REQUEST_LOADING = 'PRICE_BOOK_ITEMS_REQUEST_LOADING';
export const PRICE_BOOK_ITEMS_REQUEST_SUCCESS = 'PRICE_BOOK_ITEMS_REQUEST_SUCCESS';
export const PRICE_BOOK_ITEMS_REQUEST_FAILED = 'PRICE_BOOK_ITEMS_REQUEST_FAILED';

export const PRICE_BOOK_ITEMS_CURRENT_ACTION = 'PRICE_BOOK_ITEMS_CURRENT_ACTION';
export const PRICE_BOOK_ITEMS_RESET_ACTION = 'PRICE_BOOK_ITEMS_RESET_ACTION';